import request from '@/utils/request'

// 商品列表
export function getGoodsList() {
  return request({
    url: '/customer_service/goodsList',
    method: 'get',
  })
}

//新商品列表
export function getNewGoodsList(data: {
  current: number,
  size: number,
}) {
  return request({
    url: '/product/list',
    method: 'get',
    data
  })
}